import React from 'react';
import CardForm from 'components/CardForm';
import Header from 'components/Header';
import './CreditCardAuthorization.scss';


const CreditCardAuthorization = () => {
  const year = new Date().getFullYear();

  return (
    <div>
      <div className="page">
        <Header />
        <div className="page-bg" />
        <CardForm />
        <div className="footer">
          ©
          {' '}
          {year}
          {' '}
          by
          <a target="_blank" rel="noopener noreferrer" href="https://www.altovita.com/">AltoVita</a>
        </div>
      </div>
    </div>
  );
};

export default CreditCardAuthorization;
